// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"274":"4d2d98da","510":"b64042be","571":"a5d0fc93","814":"a985b8a0"}[chunkId] + ".js";
};